import React from "react";
import * as classNames from "classnames";
import styles from "./card.css";
import stylesTwitter from "./cardTwitter.css";

export const twitterStatus = RegExp("(twitter.com/).+(/status/).+", "gi");

export function twitterCard(info) {
	const allClassNames = classNames(styles.card, stylesTwitter.card);
	const { image, data, href } = info;

	return (
		<a href={href} className={allClassNames}>
			<div className={styles.image}>
				<div className={stylesTwitter.tweet}>{data.tweet}</div>
				{image ? (
					<div className={stylesTwitter.image}>
						<img src={image} alt="" />
					</div>
				) : null}
			</div>
			<div className={stylesTwitter.mediaObject}>
				<img src={data.avatarUrl} className={stylesTwitter.avatar} alt="" />
				<div>
					<p className={stylesTwitter.name}>{data.name}</p>
					<p className={stylesTwitter.username}>{data.username}</p>
				</div>
			</div>
		</a>
	);
}



// WEBPACK FOOTER //
// ./src/components/ui/card/cardTwitter.js